<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="unitconfigPopup()"
          >新增度量单位</el-button
        >
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
          >批量删除</RemoveButton
        >
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="unitName" label="度量单位名称"> </el-table-column>
      <el-table-column prop="unitTypeName" label="度量单位类型">
      </el-table-column>
      <el-table-column prop="isSys" label="是否系统">
        <template slot-scope="scope">
          <template v-if="scope.row.isSys">
            <el-tag type="success">是</el-tag>
          </template>
          <template v-else>
            <el-tag type="danger">否</el-tag>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | format }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <template v-if="!scope.row.isSys">
            <el-button type="text" @click="unitconfigPopup(scope.row.id)"
              >编辑</el-button
            >
            <el-button type="text" @click="unitconfigDel(scope.row.id)"
              >删除</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 度量单位表单 -->
    <el-dialog :close-on-click-modal="false"
      title="新增度量单位"
      :visible.sync="unitconfigFormVisible"
      center
    >
      <el-form
        :model="unitconfigForm"
        :size="$store.state.formSize"
        :rules="unitconfigFormRules"
        ref="refUnitconfigForm"
        label-width="150px"
      >
        <el-form-item label="度量单位名称：" prop="unitName">
          <el-input
            v-model="unitconfigForm.unitName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="度量单位类型：" prop="unitType">
          <el-select
            v-model="unitconfigForm.unitType"
            style="width:100%;"
            placeholder="请选择"
          >
            <el-option
              v-for="item in unitTypeList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="unitconfigForm.remark"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="debounceSubmit"
          >确 定</el-button
        >
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getUnitconfigList,
  getUnitTypeList,
  postUnitconfigEdit,
  putUnitconfigAdd,
  getUnitconfigDetail,
  deleteUnitconfigDel,
  delUnitList
} from '@/api/unitconfig'
const createForm = () => ({
  unitName: '',
  unitType: '',
  remark: ''
})
export default {
  data() {
    return {
      unitconfigFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      currentId: null,
      isDisabled: false,
      tableData: [],
      unitTypeList: [],
      unitconfigForm: createForm(),
      unitconfigFormRules: {
        unitName: [
          { required: true, message: '请输入度量单位名称', trigger: 'blur' }
        ],
        unitType: [
          { required: true, message: '请选择度量单位类型', trigger: 'blur' }
        ]
      },
      loading: true,
      selectionID: []
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑度量单位' : '新建度量单位'
    }
  },
  created() {
    this.debounceSubmit = debounce(300, this.unitconfigSubmit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delUnitList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getUnitconfigListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    hanleResetFormVals() {
      this.unitconfigFormVisible = false
      this.$set(this, 'unitconfigForm', createForm())
      this.$refs.refUnitconfigForm.clearValidate()
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getUnitconfigListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getUnitconfigListData()
    },
    // 删除度量单位配置
    unitconfigDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteUnitconfigDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除度量单位成功')
              this.getUnitconfigListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增/修改排班
    unitconfigSubmit() {
      this.$refs.refUnitconfigForm.validate(valid => {
        if (!valid) return false
        const changeunitconfig = this.currentID
          ? postUnitconfigEdit
          : putUnitconfigAdd
        changeunitconfig({
          unitName: this.unitconfigForm.unitName,
          remark: this.unitconfigForm.remark,
          unitType: this.unitconfigForm.unitType,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID
              ? this.$message.success('修改度量单位成功')
              : this.$message.success('新增度量单位成功')
            this.unitconfigFormVisible = false
            this.getUnitconfigListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开新增/修改表单
    unitconfigPopup(id) {
      this.$set(this, 'unitconfigForm', createForm())
      const isAdd = !id
      this.unitconfigFormVisible = true

      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getUnitconfigDetail(id).then(res => {
          if (res.status === 1) {
            this.unitconfigForm.unitName = res.data.unitName
            this.unitconfigForm.remark = res.data.remark
            this.unitconfigForm.unitType = res.data.unitType
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getUnitconfigListData()
    },
    // 刷新数据表格
    refresh() {
      this.getUnitconfigListData()
      this.$message.success('数据刷新成功')
    },
    // 获取度量单位列表
    getUnitconfigListData() {
      this.loading = true

      getUnitconfigList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    }
  },
  mounted() {
    this.getUnitconfigListData()
    // 获取度量单位类型
    getUnitTypeList().then(res => {
      this.unitTypeList = res.data
    })
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
